window.organizationId = function() {
  return window.currentOrganizationId || false;
};
